import { render, staticRenderFns } from "./lottery-info-dialog.vue?vue&type=template&id=b0862e20&scoped=true&"
import script from "./lottery-info-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./lottery-info-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./lottery-info-dialog.vue?vue&type=style&index=0&id=b0862e20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0862e20",
  null
  
)

export default component.exports